export const generalFaqGroups = [
    {
        title: "Preguntas frecuentes generales",
        items: [
            {
                question: "¿Cómo es la modalidad de cursada? ¿Qué plataforma usan para las clases?",
                answer: "Todos nuestros programas son 100% virtuales, con clases en vivo que además quedan grabadas y disponibles en la plataforma. Algunos programas puntuales incluyen una instancia de práctica presencial obligatoria. Te recomendamos revisar la ficha de cada programa para confirmar si aplica en el que te interesa. Contamos con un campus virtual propio, donde vas a encontrar todo el material, las clases y podés interactuar con el docente.",
            },
            {
                question: "¿Qué certificado obtengo al finalizar? ¿Qué validez tienen los títulos?",
                answer: "Al finalizar, obtenés un certificado con doble respaldo: de FISP y de la Facultad de Medicina de la UBA, en los programas dirigidos a graduados universitarios del área de salud. En los programas abiertos a otras carreras o personas sin título de grado, la certificación es exclusivamente de FISP. La validez es nacional e internacional en los países en que la UBA tiene convenios. La homologación en cada país depende del convenio específico que tenga la UBA con ese país, y es un trámite personal del alumno. FISP no gestiona la homologación.",
            },
            {
                question: "¿Las clases quedan grabadas?",
                answer: "Sí. Todas las clases en vivo quedan grabadas y disponibles en la plataforma virtual las 24 horas, así podés verlas cuando quieras durante toda la cursada.",
            },
            {
                question: "¿Debo asistir obligatoriamente a las clases? ¿Hay límite de faltas?",
                answer: "No se evalúa la asistencia a las clases en vivo, sino el visionado de las clases grabadas: la plataforma registra cuántas viste y cuánto tiempo, y sobre esa base se evalúa la falta. Asistir en vivo no es obligatorio, aunque sí recomendable para aprovechar el intercambio con docentes y compañeros.",
            },
            {
                question: "¿Las diplomaturas y posgrados están validados por la CONEAU?",
                answer: "Los posgrados y las diplomaturas cuentan con el título de la Facultad de Medicina de la Universidad de Buenos Aires, por lo que la UBA no necesita validar estos programas en CONEAU.",
            },
            {
                question: "¿Cuánto demoran los certificados? ¿Tengo que hacer algún trámite?",
                answer: "Los certificados de FISP se entregan a los 60 días de finalizado el curso, siempre y cuando esté abonada la totalidad del programa. Los certificados de la Facultad de Medicina de la UBA se entregan entre 8 y 10 meses después de la finalización.",
            },
            {
                question: "¿Qué documentación necesito? ¿Puedo inscribirme si todavía no recibí mi título?",
                answer: 'Se solicita el título universitario o certificado de alumno regular si estás cursando el último año, además de documentación personal. Los requisitos exactos varían según el programa: revisá el apartado "A quién está dirigido" de cada curso. Muchos de nuestros posgrados y diplomaturas aceptan estudiantes del último año de la carrera, no solo graduados.',
            },
        ],
    },
    {
        title: "Sobre pagos",
        items: [
            {
                question: "¿Puedo pagar en cuotas?",
                answer: "Sí, ofrecemos la posibilidad de abonar el programa en cuotas.",
            },
        ],
    },
    {
        title: "Sobre evaluación",
        items: [
            {
                question: "¿Cómo se evalúa el curso?",
                answer: 'El sistema de evaluación varía según el programa, pero generalmente incluye: examen parcial, uno en las diplomaturas y dos en la mayoría de los posgrados, actividad en foro, entrega de trabajos prácticos y examen final. Algunos programas suman una instancia de práctica final presencial. El detalle exacto está en la sección "Sistema de evaluación" de cada curso.',
            },
            {
                question: "¿Qué pasa si desapruebo un examen? ¿Si no rindo en tiempo y forma tengo que pagar un derecho de examen?",
                answer: "Si desaprobás un examen, tenés la posibilidad de rendir un recuperatorio. Los exámenes se dejan activos en nuestro campus virtual durante una semana para que los puedan resolver cuando tengan el tiempo. Fuera de ese plazo, se deberá pagar un derecho de examen cuyo costo es igual al 50% de una cuota mensual del curso actualizada a la fecha.",
            },
        ],
    },
    {
        title: "Sobre cursar varios programas",
        items: [
            {
                question: "¿Puedo hacer más de una diplomatura o posgrado a la vez? ¿Hay descuento si me inscribo en más de un programa?",
                answer: "Sí, es posible cursar más de un programa a la vez. Los descuentos que ofrecemos, sin embargo, no son específicos por combinar programas: aplican para ex alumnos y para quienes abonan el curso en su totalidad en un solo pago.",
            },
        ],
    },
    {
        title: "Sobre alumnos de otros países",
        items: [
            {
                question: "¿Puedo inscribirme si soy de otro país? ¿En qué moneda se paga?",
                answer: "Sí. Al ser 100% online y estar dirigido a graduados de universidades argentinas o extranjeras, según el perfil de cada programa, no hay una restricción geográfica para inscribirse desde otro país. Se paga en la moneda local del país desde donde se realiza el pago.",
            },
        ],
    },
];

export const courseSpecificFaqs = {
    "posgrado-dermatologia-estetica-terapeutica": {
        title: "Sobre el posgrado",
        items: [
            {
                question: "¿Incluye prácticas o demostraciones clínicas? ¿Cuántas son?",
                answer: "Sí. El programa incluye unidades de prácticas correspondientes a tratamientos faciales y corporales, más una instancia de práctica final presencial de 2 días.",
            },
            {
                question: "¿Las prácticas están incluidas en el precio final?",
                answer: "Sí, las prácticas, al igual que los materiales, están incluidos en el precio.",
            },
            {
                question: "¿Los alumnos pueden participar en las prácticas o solo observar?",
                answer: "Depende del procedimiento: en algunos, el docente permite que los alumnos participen de forma activa, mientras que en otros la instancia es de observación. Esto se debe a que las prácticas se realizan sobre pacientes reales, por lo que la participación queda a criterio del profesional a cargo en cada caso.",
            },
            {
                question: "¿Está dirigido exclusivamente a médicos dermatólogos?",
                answer: "No. Está dirigido a médicos en general y odontólogos.",
            },
            {
                question: "¿Puedo poner un consultorio si hago este posgrado?",
                answer: "Lo que te habilita legalmente a atender pacientes en un consultorio es tu título de médico y tu matrícula profesional, no el posgrado en sí. Este programa te da formación especializada en dermatología estética y terapéutica, pero no reemplaza una especialidad médica formal (que tiene otro proceso y duración).",
            },
        ],
    },
    "diplomatura-bioremodelacion-facial": {
        title: "Sobre la diplomatura",
        items: [
            {
                question: "¿Incluye alguna instancia de práctica presencial?",
                answer: "Sí, incluye 1 jornada de práctica final presencial al finalizar la cursada.",
            },
            {
                question: "¿Las prácticas están incluidas en el costo total de la diplomatura?",
                answer: "Sí, tanto las prácticas como los materiales están incluidos.",
            },
            {
                question: "¿Los alumnos pueden participar en las prácticas o solo observar?",
                answer: "Depende del procedimiento: en algunos, el docente permite que los alumnos participen de forma activa, mientras que en otros la instancia es de observación. Esto se debe a que las prácticas se realizan sobre pacientes reales, por lo que la participación queda a criterio del profesional a cargo en cada caso.",
            },
        ],
    },
    "diplomatura-microtrasplante-capilar": {
        title: "Sobre la diplomatura",
        items: [
            {
                question: "¿Incluye práctica presencial? ¿Cuántos días son?",
                answer: "Sí. Incluye una práctica hands-on full sobre pacientes reales, distribuida en 2 días al finalizar la cursada. Por esta modalidad con pacientes reales, los cupos están limitados a solo 5 vacantes.",
            },
        ],
    },
    "diplomatura-ginecologia-regenerativa-estetica-funcional": {
        title: "Sobre la diplomatura",
        items: [
            {
                question: "¿Qué especialidad necesito tener para inscribirme?",
                answer: "Está dirigida a médicos con especialidad en Ginecología, Tocoginecología, Obstetricia o Urología, ya sea en curso (residencia o concurrencia) o finalizada.",
            },
        ],
    },
    "diplomatura-nutricion-deportiva": {
        title: "Sobre la diplomatura",
        items: [
            {
                question: "¿Necesito ser profesional de la salud para hacer esta diplomatura?",
                answer: "No. Es un programa de acceso amplio: está dirigido a profesionales de la salud y también a profesionales de otras carreras, estudiantes de último año, e incluso personas con título secundario.",
            },
            {
                question: "¿Voy a aprender a armar planes nutricionales?",
                answer: "Sí. El programa incluye contenidos de valoración del estado nutricional, nutrición hospitalaria y abordaje nutricional en distintas patologías, con herramientas para diseñar planes de alimentación personalizados.",
            },
        ],
    },
    "diplomatura-marketing-medico": {
        title: "Sobre la diplomatura",
        items: [
            {
                question: "¿Necesito ser profesional de la salud para hacer esta diplomatura?",
                answer: "No. Es un programa de acceso amplio, abierto también a profesionales de otras carreras.",
            },
        ],
    },
    "posgrado-nutricion-clinica": {
        title: "Sobre el posgrado",
        items: [
            {
                question: "¿Está dirigido únicamente a nutricionistas?",
                answer: "No. Está dirigido a Licenciados/as en Nutrición, Médicos de Familia, Clínicos, Generalistas, y especialistas en Endocrinología, Psiquiatría y Cardiología, entre otras especialidades que requieran conocimientos de nutrición.",
            },
            {
                question: "¿Puedo atender en un consultorio si hago este posgrado?",
                answer: "Lo que te habilita legalmente a atender pacientes es tu título de grado (médico o licenciado en Nutrición) y tu matrícula profesional, no el posgrado en sí. Este programa te da formación especializada en nutrición clínica, pero no reemplaza una especialidad médica formal (que dura 3 años).",
            },
            {
                question: "¿Voy a aprender a armar planes nutricionales?",
                answer: "Sí. El programa incluye contenidos de valoración del estado nutricional, nutrición hospitalaria y abordaje nutricional en distintas patologías, con herramientas para diseñar planes de alimentación personalizados.",
            },
        ],
    },
    "posgrado-gestion-administracion-enfermeria": {
        title: "Sobre el posgrado",
        items: [
            {
                question: "¿Qué oportunidades profesionales brinda esta formación?",
                answer: "El programa forma en gestión, liderazgo y toma de decisiones aplicadas a servicios de enfermería, orientado a roles de coordinación, jefatura o dirección de equipos de enfermería en instituciones de salud.",
            },
            {
                question: "¿Puedo hacer el posgrado si tengo la tecnicatura en enfermería?",
                answer: "No, se requiere la Licenciatura en Enfermería para poder hacer los posgrados de esta rama.",
            },
        ],
    },
    "posgrado-toxicologia": {
        title: "Sobre el posgrado",
        items: [
            {
                question: "¿El título es de Toxicólogo?",
                answer: "No. El título formal de especialista en Toxicología (Toxicólogo) requiere una especialidad médica de 3 años. Este posgrado no equivale a esa formación de especialista, sino que otorga una certificación de posgrado en el área.",
            },
        ],
    },
    "diplomatura-criminalistica-ciencias-forenses": {
        title: "Sobre la diplomatura",
        items: [
            {
                question: "¿Qué conocimientos previos tengo que tener?",
                answer: "No se requieren conocimientos previos específicos en criminalística o medicina legal; el programa está diseñado para introducir estos temas desde sus fundamentos.",
            },
            {
                question: "¿Es solo para médicos o puedo hacerlo siendo profesional de otra carrera?",
                answer: "No es exclusivo para médicos. Está dirigido a profesionales de la salud y estudiantes de último año, y también a profesionales de otras carreras con título de grado (o estudiantes de último año), graduados de universidades argentinas o extranjeras.",
            },
        ],
    },
};
